import { Euler, Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Scharnier from "../../doors/scharnier";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SingleScharnierSinglePanelSingleScharnierStairsProps
  extends ConfigurationProps {}
const SingleScharnierSinglePanelSingleScharnierStairs: React.FC<
  SingleScharnierSinglePanelSingleScharnierStairsProps
> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SingleScharnierSinglePanelSingleScharnierStairsProps) => {
  const position0 = new Vector3(-0.465, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);

  // in non-eigenwijs configuration: height = 2960

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1, position2]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Scharnier
        materials={materials}
        position={positions[0]}
        index={0}
        rotation={new Euler(0, 0, 0)}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
      />
      <Paneel
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
      <Scharnier
        materials={materials}
        position={positions[2]}
        index={2}
        rotation={rotation}
        frameSettings={doorSettings?.tertiary?.frameSettings}
        lockSettings={doorSettings?.tertiary?.lockSettings}
      />
    </group>
  );
};

export default SingleScharnierSinglePanelSingleScharnierStairs;
